/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/Report-TH.css";

import { Modal } from "bootstrap";
import * as funcAll from "../../util/funcAll";

import FollowTH from "../menu/Follow-up-oldTH";

/////////////   Redux  //////////////
import { useSelector, useDispatch } from "react-redux";
import SecureStorage from "react-secure-storage";

export default function FollowPageOldTH(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const [alert_header, setAlertHeader] = useState(); //หัวข้อ alert
  const [alert_content, setAlertContent] = useState(); //รายละเอียก alert
  const [alert_description, setAlertDescription] = useState(); //รายละเอียก alert
  const modal_alert_ref = useRef(); //สำหรับ alert
  const [modal_alert_close, setModalAlertClose] = useState(null); //สำหรับ alert

  const [ticket_id, setTicketId] = useState("");
  const [password, setPassword] = useState("");
  const [error_message_password, setErrorMessagePassword] = useState("");
  const [success, setSuccess] = useState(false);
  const detailReport2 = sessionStorage.getItem("detailReport2");
  const authorizeCase = JSON.parse(sessionStorage.getItem("authorization"));
  const [hasChecked, setHasChecked] = useState(false);
  const alert_fail = (
    <span class="material-icons text-danger post-alert-icon my-3">cancel</span>
  );

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  useEffect(() => {
    if (detailReport2) {
      setSuccess(true);
    } else {
    }
  }, [detailReport2]);

  useEffect(() => {
    if (authorizeCase && !hasChecked) {
      setHasChecked(true);

      showLoadingAnimation();
      // setTicketId(authorizeCase["ticket_report"]);
      // setPassword(authorizeCase["password_report"]);

      funcAll
        .checkCasePassword(
          authorizeCase["ticket_report"],
          authorizeCase["password_report"],
          "en"
        )
        .then((res) => {
          if (res["status"] === "success") {
            SecureStorage.setItem("detailReport", res["results"]);
            sessionStorage.setItem(
              "detailReport2",
              JSON.stringify(res["results"])
            );
            setErrorMessagePassword("");
            hideLoadingAnimation();
            props.reloadNav(authorizeCase["ticket_report"]);
            setTimeout(() => {
              setSuccess(true);
            }, 500);
          } else {
            SecureStorage.setItem("detailReport", []);
            setErrorMessagePassword(
              "* Wrong Ticket ID or password. Please check and enter again."
            );
            hideLoadingAnimation();
            setTimeout(() => {
              setSuccess(false);
            }, 500);
          }
        });
    } else {
    }
  }, [authorizeCase]);

  function showLoadingAnimation() {
    document.getElementById("loading-container").style.display = "flex";
  }

  // Hide the loading animation
  function hideLoadingAnimation() {
    document.getElementById("loading-container").style.display = "none";
  }

  const handleBtnAlertClose = async () => {
    modalHide(modal_alert_close);
  };

  const modalShow = (mRef, setModals) => {
    const modal = new Modal(mRef.current, { keyboard: false });
    setModals(modal);
    modal.show();
  };

  const modalHide = (modal_hide) => {
    modal_hide.hide();
  };

  const setAlert = async (header_text, icon, description) => {
    setAlertHeader(header_text);
    setAlertContent(icon);
    setAlertDescription(description);
    modalShow(modal_alert_ref, setModalAlertClose);
  };

  const sendReportData = async (e) => {
    e.preventDefault();
    console.log("Success");
    // setDisableBtnSendData(true);
  };

  const handleCheckPassword = () => {
    const dispatchAuthorize = () => {
      let authorize = {
        ticket_report: ticket_id,
        password_report: password,
      };
      SecureStorage.setItem("authorization", authorize);
    };
    dispatchAuthorize();

    funcAll.checkCasePassword(ticket_id, password, "th").then((res) => {
      if (res["status"] === "success") {
        setSuccess(true);
        SecureStorage.setItem("detailReport", res["results"]);
        sessionStorage.setItem("detailReport2", JSON.stringify(res["results"]));
        setErrorMessagePassword("");
      } else {
        setSuccess(false);
        SecureStorage.setItem("detailReport", []);
        setErrorMessagePassword(
          "*Ticket ID หรือ รหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบและกรอกใหม่อีกครั้ง"
        );
      }
    });
  };

  return (
    <>
      <>
        {detailReport2 ? (
          <>
            <FollowTH />
            <div
              className="loading-container"
              id="loading-container"
              style={{ height: "1rem" }}></div>
          </>
        ) : (
          <div className="container-in-tab-content">
            {authorizeCase ? (
              <div>
                <div className="loading-container" id="loading-container">
                  <div className="loader" />
                  <p>Waiting...</p>
                </div>
              </div>
            ) : (
              <>
                <div
                  className="container-followPage"
                  style={{
                    padding: "2rem",
                    margin: "0 auto",
                    height: "fit-content",
                  }}>
                  <form
                    id="myform"
                    class="needs-validation"
                    novalidate
                    onSubmit={sendReportData}>
                    <div className="container-title pt-2">
                      <p className="txt-th title">Ticket ID</p>
                    </div>

                    <input
                      required
                      type="text"
                      className="form-control shadow-style input"
                      value={ticket_id}
                      onChange={(e) => setTicketId(e.target.value)}
                    />

                    <div className="container-title pt-3">
                      <p className="txt-th title">Pin</p>
                    </div>

                    <input
                      required
                      type="text"
                      className="form-control shadow-style input"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="mt-3">
                      <p className="err-message-txt">
                        {error_message_password}
                      </p>
                    </div>

                    <a
                      className="btn-report my-5"
                      onClick={() => handleCheckPassword()}>
                      <p>ดูความก้าวหน้า</p>
                    </a>
                  </form>
                </div>

                <div className="loading-container" id="loading-container">
                  {/* <div className="loader" />
                <p>Waiting...</p> */}
                </div>
              </>
            )}
          </div>
        )}
      </>
    </>
  );
}
